/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base user record returned by the API.
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    role: UserRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firebaseUid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    accountStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastLoginAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    readonly updatedAt?: Date;
}


/**
 * @export
 */
export const UserRoleEnum = {
    Owner: 'owner',
    Admin: 'admin',
    Member: 'member',
    Viewer: 'viewer'
} as const;
export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'role': json['role'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'firebaseUid': json['firebaseUid'] == null ? undefined : json['firebaseUid'],
        'accountStatus': json['accountStatus'] == null ? undefined : json['accountStatus'],
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: Omit<User, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'phone': value['phone'],
        'role': value['role'],
        'companyId': value['companyId'],
        'firebaseUid': value['firebaseUid'],
        'accountStatus': value['accountStatus'],
        'lastLoginAt': value['lastLoginAt'] == null ? undefined : ((value['lastLoginAt'] as any).toISOString()),
    };
}

